<template>
    <!-- <div class="container"> -->
        <div class="row">
           
            <div class="col-12 col-md-8">
                <div class="row ml-4 max-95 mb-2 max-height-36">
                    <div class="col-xl-7 center-column ">
                        <img id="lens" src="../../assets/images/search_icon_u33.svg" width="20"
                                />
                        <input type="text"  v-model="module_search_key" placeholder="Search" class="shopify-search"/>
                        <img class="line line-heigh-70 pull-right end-col" src="../../assets/images/u37-hr-line.svg"/>
                    </div>
                    <div class="col-sm-1 width-fit-content center-column padding-left-0">
                       
                         <a class="pointer" @click="visible_filter = !visible_filter">
                                <img class="" id="" src="../../assets/images/filter_list_u41.svg" width="19"
                                />
                        </a>
                        <span class="top-section-text margin-right-15 icon-side-text">Filter</span>
                         <img class="line line-heigh-70 pull-right" src="../../assets/images/u37-hr-line.svg"/>
                    </div>
                    <div class="col-sm-3 center-column padding-left-0">
                        <div class="">
                            <img class="" id="" src="../../assets/images/sort_u40.svg" width="19"
                                />
                            <div class="icon-side-text sort-filter">
                               <v-select track-by="id" label="name"
                                            :searchable="false"
                                            placeholder="Options"
                                            :reduce="name => name.id"
                                            v-model="sorting_array_" 
                                            :options="sort_options" 
                                            />
                         </div>
                        </div>
                    </div>
                </div>
                <div class="row max-95 margin-top-2 padding-7 justify-content-around">
                        <b-collapse id="collapse-4" v-model="visible_filter" class="card-holder">
                            <!-- <div class="col-equal"> -->
                                <!-- <b-card class=""> -->
                                    <!-- <div class="input-content input-content-horizonal"> -->
                                        <label class="filter-title">Languages</label>
                                        <v-select @input="filterInput()" multiple :searchable="true" track-by="id" label="name"
                                        placeholder="Options"
                                            :value="language_array_" 
                                            :reduce="name => name.id" 
                                            :options="languages_all" class="filter-select"
                                            />
                                    <!-- </div> -->
                                <!-- </b-card> -->
                            <!-- </div> -->
                         </b-collapse>
                        <b-collapse id="collapse-5" v-model="visible_filter" class="card-holder">
                            <!-- <div class="col-equal"> -->
                                <!-- <b-card class=""> -->
                                    <label class="filter-title">Categories</label>
                                    <!-- <div class="input-content input-content-horizonal "> -->
                                        
                                        <v-select @input="filterInput()" multiple :searchable="true" track-by="id" label="name"
                                        placeholder="Options"
                                            :value="category_array_" 
                                            :reduce="name => name.id" 
                                            :options="category_all" class="filter-select"
                                            />
                                    <!-- </div> -->
                                <!-- </b-card> -->
                            <!-- </div> -->
                         </b-collapse>
                        <!-- <div v-if="visible_filter" class="col-xs-05 margin-right-left-3">
                          <img class="line line-heigh-90" src="../../assets/images/u37-hr-line.svg"/>
                         </div> -->
                        <!-- <b-collapse id="collapse-4" v-model="visible_filter" class="card-holder">
                            <div class="col-equal">
                                     <div class=" input-content input-content-horizonal">
                                          <label class="filter-title">Categories</label>
                                              <v-select name="country_code" multiple :searchable="true" label="name"
                                            placeholder="Language"
                                            :value="language_array_" 
                                            :reduce="name => name.id" 
                                            :options="languages_all" class="filter-select"
                                            />

                                     </div>
                            </div>
                         </b-collapse> -->
                
                  </div>
                <div class="row max-95 ml-2 mt-4 justify-content-around">
                    <div id="in-class-rectangle">
                        <a class="pointer" @click="openInClassModal()">
                            <div class="card-image-holder">
                                <div class="position-abs">
                                    <div class="in-class-added-text">
                                        <span>
                                        <img class="in-class-icon" src="../../assets/images/icons8_classroom.svg">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <div class="row card-title-section">
                            <div class="margin-left-16">
                                <div class="in-class-text-holder">
                                    In-class Content
                                </div>
                            </div>    
                        </div>
                        <div class="card-title-section card-bottom-row">
                            <div class="margin-left-16 position-time">
                                <div class="time-text ">
                                    <!-- Empty Placeholder -->
                                </div>
                            </div>
                            <div class="">
                                <a class="pointer" @click="openInClassModal()">
                                    <div class="in-class-add-button cart-icon">
                                        <a class="pointer">
                                            <img class="" id="" src="../../assets/images/u52b_plus.svg" width="22" /> 
                                        </a>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-12 col-md-8"> -->
                        <div v-for="(mod,index) in module_list" :key="index">
                           
                            <div id="rectangle" :class="{ 'loading' : loading_table_providers } ">
                                <a class="pointer" @click="openModal(mod, index)">
                                <div class="card-image-holder">
                                    <div class="position-abs">
                                        <div v-if="mod.added" class="added-text"><div class="added-text-middle"><span>Added to your program</span></div></div>
                                        <img class="card-image" :src="mod.image">
                                    </div>
                                </div>
                               </a>
                                <div class="row card-title-section">
                                 
                                    <div class="margin-left-16">
                                        <div  v-if="mod.name && mod.name.EN && mod.name.EN.length" class="text-holder">
                                            {{mod.name['EN']}}
                                        </div>
                                        <div v-else class="text-holder">
                                            {{mod.title}}
                                        </div>
                                    </div>
                                     
                                    <shopify-language-icon :mod="mod" />
                                     
                                 </div>
                                 
                                 <div class="card-title-section card-bottom-row">
                                     <div class="margin-left-16 position-time">
                                        <div class="time-text ">
                                            <img class="img-font-size" id="" src="../../assets/images/access_time_u51.svg"
                                                /> 
                                                <span class="duration-text">{{ secondsToHms((mod.duration), true) }}</span>
                                        </div>
                                     </div>
                                     <div class="">
                                          <a class="pointer" @click="openModal(mod, index)">
                                         <div v-if="mod.added" class="cart-icon on-cart-button">
                                            <img class="" id="" src="../../assets/images/u63.svg" width="22" />
                                        </div>
                                        <div v-else class="add-button cart-icon">
                                            <a class="pointer">
                                                 <img class="" id="" src="../../assets/images/u52_plus.svg" width="22" />
                                           
                                            </a>
                                        </div>
                                          </a>
                                     </div>
                                 </div>
                             </div>
                        </div>
                        <i aria-hidden="true"></i>
                        <i aria-hidden="true"></i>
                        <div v-if="no_module_return && module_list.length == 0" class="build-program-title mt-1 mb-2">
                            There are no modules within this criteria
                        </div>
                        <div v-if="no_module_return && module_list.length > 0" class="build-program-title mt-1 mb-2">
                            There are no more modules within this criteria
                        </div>
                </div>
                  <div id="spinner" v-if="loading_table_providers"></div>
            </div>
            <div class="col-xs line-section">
                 <img class="line line-heigh-50 pull-right end-col" src="../../assets/images/u37-hr-line.svg"/>
            </div>
            <div class="col-12 col-md-4 ml-n3 mr-n20">
                
                <shopify-cart v-if="show_cart" 
                :current_program="current_program"
                :module_list="module_list"
                @updateProgram="updateProgramWait"
                @openModuleFromcart="openModuleFromcart"
                @removeModuleFromChart="removeModuleFromChart"
                @closeModal="closeModal"
                ></shopify-cart>
            </div>
              <div v-if="show_modal_current_module">
                <b-modal ref="moduleDetail" id="modal-multi-2" size="lg" v-model="show_modal_current_module"  ok-only ok-variant="secondary" ok-title="" @hide="closeModal" hide-footer hide-header>
                   <div class="modal-row">
                        <div class="col-left">
                  
                        <div class="module-detail-image-holder">
                             <img class="card-image modal-image" :src="modal_module_current.module.image">
                             <div class="module-detail-lesson-title-text">
                                 <div class="overflow-hidden">
                                   {{modal_module_current.module.name['EN']}}
                                 </div>
                                <div class="module-detail-time-holder">
                                 <img class="mb-1" src="../../assets/images/normal_access_time_u549.svg"/> 
                                      {{ secondsToHms((modal_module_current.module.duration), true) }}
                                </div>
                             </div>

                        </div>
                        <div class="module-detail-notes">
                            <!-- {{modal_module_current.module.description}} -->
                            {{currentModuleDescription}}
                        </div>
                        <div class="module-detail-languages">
                            <img id="" src="../../assets/images/language_u50.svg" width="18"
                                />
                                <div class="language-text-holder">
                                <div class="" v-for="(lang,index) in modal_module_current.module.languages" :key="index">
                                    <p class="mr-1">
                                    {{lang}}
                                        
                                    </p>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="col-right">
                            <a @click="closeModal">
                              <img  height="40" width="22" src="../../assets/images/delete-cancel-icon.svg"  class="x-button pointer close-button-module-detail" />
                            </a>
                             <div class="module-detail-lessons-header"> Lessons 
                                                           
                             </div>
                             
                            <div class="table-view">
                                <div v-for="(lesson, index) in modal_module_current.module.lessons" :key="index">
                                    <div class="lesson-row">
                                      <div class="lesson-index"> {{index + 1}}</div>
                                      <div class="lesson-name">
                                          {{lesson.title}} 
                                      </div>
                                    </div>
                                   
                                    <div class="lesson-duration mb-2">
                                        {{lesson.duration.replace(/^0+/, '')}}
                                    </div>
                                      

                                     
                                      <!-- <div class="width-10">
                                       <span class="lesson-duration">{{lesson.duration}}</span>
                                      </div> -->

                                    
                                </div>
                               
                            </div>
                            <div class="module-detail-quiz-section">
                                <div class="quiz-section-flex">
                                    
                                        <img id="" class="quiz-start-icon" :class="{'disabled-button': modal_module_current.with_quiz == false}" src="../../assets/images/normal_u556.svg" width="18"
                                    />  
                                        <div :class="{'disabled-button': modal_module_current.with_quiz == false}" class="final-quiz">
                                            Final quiz
                                            <span class="final-quiz-duration"> {{modal_module_final_quiz_duration}}</span>
                                        </div>
                                   <!--  -->
                                    <a @click="modalQuizOptionSelected" class="cursor-pointer">
                                    <div class="quiz">
                                        <div :class="{'cursor-not-allowed': !modal_module_has_quiz_module}">
                                         <div class="margin-top-10 "  :class="{'font-weight-700': modal_module_current.with_quiz, 'disabled-button': !modal_module_quiz_option }" >With a quiz</div>
                                         <div v-if="modal_module_current.with_quiz">
                                          <img id="" class="right-triangle" src="../../assets/images/normal_u563.svg" />
                                          <img id="" class="added-tick" src="../../assets/images/normal_u564.svg" width="18" />
                                        </div>
                                      </div>
                                    </div>
                                    </a>

                                    <a @click="modalNonQuizOptionSelected" class="cursor-pointer">
                                    <div class="quiz" @click="modalNonQuizOptionSelected">
                                         <div class="margin-top-10 " :class="{'font-weight-700': modal_module_current.without_quiz}" >Without a quiz</div> 
                                          <div v-if="modal_module_current.without_quiz">
                                            <img id="" class="right-triangle" src="../../assets/images/normal_u563.svg" />
                                            <img id="" class="added-tick" src="../../assets/images/normal_u564.svg" width="18" />
                                         </div>
                                    </div>
                                    </a>
                                </div>
                                <div class="mb-2">
                                    <div v-if="!modal_module_current.module.added">
                                     <button class="add-to-program-button"  
                                     :class="{'disabled-button':modal_button_disabled}" @click="addModuleToCart(modal_module_current, modal_module_current.index)">Add to program</button>
                                    </div>
                                    <div v-else>
                                     <!-- <button class="remove-from-program-button"  @click="removeModuleFromChart(modal_module_current.module, true)">Remove</button> -->
                                     <button class="remove-from-program-button"  @click="openRemoveModuleDialog()">Remove</button>
                                     <button class="add-to-program-button save-module-button"  
                                   
                                     @click="updateModuleInCart(modal_module_current.module, modal_module_current.index)">Save</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-modal> 
            </div>
            <div v-if="show_in_class_modal">
                <b-modal id="" body-class="p-0" v-model="show_in_class_modal" size="lg" ok-only ok-variant="secondary" ok-title="" @hide="closeModal" hide-footer hide-header>
                    <div class="container-fluid p-0">
                        <div class="row">
                        <!-- Column 1 -->
                        <div class="col-md-4">
                            <!-- Row 1 -->
                            <div class="row">
                                <div class="col">
                                    <div class="in-class-modal-image">
                                        <img class="in-class-icon" src="../../assets/images/icons8_classroom.svg">
                                    </div>
                                </div>
                            </div>
                            <!-- Row 2 -->
                            <div class="row">
                                <div class="col m-3 in-class-duration-text">
                                    <h4>In-Class Content</h4>
                                    <p>This Module is designed to be used for In-Class sessions.</p>
                                    <p>
                                        Do <span class="duration-text">NOT </span>
                                        add this module to Remote/Mobile training programs.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Column 2 -->
                        <div class="col-md-8">
                            <div class="my-5 mr-5">
                                
                            <form @submit.prevent="addCustomModuleToCart">

                                <!-- Duration fields -->
                                <label for="" class="mb-2 in-class-label-text">Duration</label>
                                <div class="form-group row">
                                    <label for="hours" class="ml-3 col-form-label">Hours: </label>
                                    <div class="col-sm-4">
                                        <!-- <input type="number" class="form-control" id="hours" v-model="custom_module.duration.hours" min="0" placeholder="Hours"> -->
                                        <select class="form-control" id="hours" v-model="custom_module.duration.hours">
                                            <option v-for="hour in 10" :key="hour" :value="hour - 1">{{ hour - 1 }}</option>
                                        </select>
                                    </div>
                                    <label for="minutes" class="ml-3 col-form-label">Minutes: </label>
                                    <div class="col-sm-4">
                                        <select class="form-control" id="minutes" v-model="custom_module.duration.minutes">
                                            <option v-for="minute in 4" :key="minute" :value="(minute - 1) * 15">{{ ((minute - 1) * 15) }}</option>
                                        </select>
                                    </div>
                                    <div class="ml-3" v-if="show_custom_error_dur">
                                        <span style="color: red; font-size: 16px;">Duration must be greater than 0</span>
                                    </div>
                                </div>

                                <!-- Text displaying the selected duration -->
                                <div class="form-group in-class-duration-text">
                                    This Module will add 
                                    <span class="duration-text">{{ custom_module.duration.hours }} </span>
                                    hours and 
                                    <span class="duration-text">{{ custom_module.duration.minutes }} </span>
                                    minutes to this Program.
                                </div>

                                <div class="form-group">
                                    <label for="title" class="in-class-label-text">Title</label>
                                    <input type="text" class="form-control" id="title" v-model="custom_module.name" placeholder="Enter Custom Module Title">
                                    <div v-if="show_custom_error_title">
                                        <span style="color: red; font-size: 16px;">Please Enter a Title</span>
                                    </div>
                                </div>


                                <div class="form-group">
                                    <label for="message" class="in-class-label-text">Personalized Certification Text</label>
                                    <textarea class="form-control" id="message" v-model="custom_module.description" rows="3" placeholder="Enter Custom Module Certification Text"></textarea>
                                </div>

                                <div class="form-group">
                                    <label for="link" class="in-class-label-text">Link to Documentation</label>
                                    <input type="text" class="form-control" id="link" v-model="custom_module.external_link" placeholder="Enter Link To Documents">
                                </div>

                                <br>
                                
                                <button type="submit" class="btn btn-primary">Add To Program</button>
                            </form>
                            </div>
                        </div>
                        </div>
                    </div>
                </b-modal>
            </div>
             <div v-if="show_remove_module">
                <remove-module-dialog 
                :ok_title="'Remove'"
                :remove_modal="show_remove_module"  
                :modalToRemove="modal_module_current"
                 @removeModuleFromChart="removeModuleFromChart"
                 @closeModal="closeModal"
                 :modal_view="true"></remove-module-dialog>


             </div>
               
    </div>
</template>
<script>
import ShopifyCart from './ShopifyCart'
import ShopifyLanguageIcon from './ShopifyLanguageIcon'
import RemoveModuleDialog from './RemoveModuleDialog'
import MixinSME from '../sme/MixinSME';
export default {
    mixins: [MixinSME],
    components:{
        ShopifyCart,
        ShopifyLanguageIcon,
        RemoveModuleDialog
    },
    data() {
        return {
            id: this.$route.params.id,
            tooltip:false,
            loading_table_providers:false,
            model_completion:'',
            visible_filter:false,
            visible_sorting:false,
            scrolledToBottom:false,
            edit_module_chart:false,
            show_organization_list:false,
            sort_options: [
            { id: 'alphanumeric', name: 'A - Z' },
            { id: '-alphanumeric', name: 'Z - A' },
            { id: '-duration', name: 'Longest - Shortest' },
            { id: 'duration', name: 'Shortest - Longest' }
            ],
            pagination_existing_modules:{

            },
            module_search_key:'',
            module_list: [],
            languages_all:[],
            language_array_:[],
            category_all:[],
            category_array_:[],
            sorting_array_:{
                id:'alphanumeric',
                name:'A - Z'
            },
            show_filter:false,
            awaitingSearch: false,
            current_program:{
                id: this.$route.params.id,

                modules:{

                }
            },
            modal_module_current:{
                without_quiz:false,
                with_quiz:false,
                initial_id:'',
                initial_selection_with_quiz:'',
                initial_selection_without_quiz:'',
                quiz_module:{
                    lessons:[
                        {duration:0}
                    ]
                }
              
            },
            custom_module: {
                duration: {
                    hours: 0,
                    minutes: 0,
                },
                name: '',
                description: '',
                order: 1,
                notes: '',
                external_link: '',
            },
            show_custom_error_dur: false,
            show_custom_error_title: false,
            show_modal_current_module:false,
            show_remove_module:false,
            show_in_class_modal: false,
            page:0,
            no_module_return:false,
            show_cart: false,
        }
    },
    watch:{
        module_search_key: function(){
            //change no module to false
            this.no_module_return = false
            if (!this.awaitingSearch) {
            setTimeout(() => {
                this.module_list = [] // List might have duplication which may be related with delay, we will be resetting module lis in here at first
                this.getExistingModules(true);
                this.awaitingSearch = false;
            }, 1000); // 1 sec delay
            }
            this.awaitingSearch = true;
        },
        language_array_ : function(val,oldval){
             //change no module to false
            this.no_module_return = false
            if(val.length == 0){
                //this.getExistingModules(true)
            }
            else if(val.length >1){
                let index_all = val.findIndex( x => x.id == '-1')
                //check if index_all is 0, then just remove it from array
                if(index_all == 0){
                 this.language_array_ = this.language_array_.filter(elem =>{ return elem.id != ''})
                }else{
                    if(index_all != -1){
                        this.language_array_ = []
                        this.language_array_ = [{id : '-1',
						name : 'None'}]
                    }
                }
            }
        },
        sorting_array_: function(val){
            this.getExistingModules(true)
        }
    },
    computed : {
        language_array: function(){
            if(this.language_array_.length>0){
                return this.language_array_.map(elem => { return elem.id})
            }else{
                return ''
            }
        },
        category_array: function(){
            if(this.category_array_.length>0){
                return this.category_array_.map(elem => { return elem.id})
            }else{
                return ''
            }
        },
        currentModuleDescription: function(){
            if(this.modal_module_current.module.description){
                //check if language filter initialized, try to find description with chosen language
                if(this.language_array_.length > 0){
                        if(this.modal_module_current.module.description[this.language_array_[0].id] != null){
                          return this.modal_module_current.module.description[this.language_array_[0].id]
                        }
                }else{
                    //else try giving englishd description
                    if (this.modal_module_current.module.description['EN'] != null){
                        return this.modal_module_current.module.description['EN']
                    }else{
                        return ''
                    }

                }
            }else{
                return ''
            }
        },
        modal_module_quiz: function(){
            if(this.modal_module_current){
                if(this.modal_module_current.module.has_quiz && this.modal_module_current.module.base_module_id != null){
                    this.getModuleQuizData("base_module_id")
                    return true
                }else{
                    return false
                }
            }
        },
        modal_module_quiz_option: function(){
            if(this.modal_module_current.with_quiz || (this.modal_module_current.initial_id == this.modal_module_current.module.quiz_module_id) || this.modal_module_current.module.quiz_module_id != null){
                this.getModuleQuizData("quiz_module_id")
                return true
            }else{
                return false
            }
        },
        modal_button_disabled: function(){
            if(this.modal_module_current.added || this.modal_module_current.with_quiz || this.modal_module_current.without_quiz){
                return false;
            }else{
                return true
            }

        },
        modal_module_final_quiz_duration: function(){
            if(this.modal_module_current.with_quiz && this.modal_module_current.module.added){
                let length = this.modal_module_current.module.lessons.length
                return this.modal_module_current.module.lessons[length-1].duration
            }
            else if(this.modal_module_current.quiz_module){
               let length =  this.modal_module_current.quiz_module.lessons.length
                return this.modal_module_current.quiz_module.lessons[length-1].duration
            }
        },
        modal_module_has_quiz_module: function(){
            if(this.modal_module_current.module.added){
                if(this.modal_module_current.initial_selection_with_quiz){
                    return true
                }
            }
            if(this.modal_module_current.with_quiz == true || this.modal_module_current.quiz_module.id ){
                return true
            }else{
                return false
            }
           
        }
    },
    mounted(){
        window.onscroll = () => {
            let dee = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight +2
            let bottomOfWindow =  dee  >= (document.documentElement.offsetHeight)

            if (bottomOfWindow && (!document.body.classList.contains('refreshing')) ) {
                document.body.classList.add('refreshing');
                setTimeout( () => {
                    this.scrolledToBottom = true 
                    if(this.no_module_return){
                        return
                    }else{
                        this.getExistingModules(false)
                        window.scroll(0, window.pageYOffset - 50)     
                    }
                },1000)
               
            }
        }
    },
    created : function(){
        this.getProgram();
        this.getAvailableLanguages();
        this.getAvailableCategories();
    },
    methods : {
        modalQuizOptionSelected: function(){
            if(this.modal_module_current.with_quiz){
                return
            }else{
                this.modal_module_current.quiz_updated = true
                this.moduleQuizBaseDataSwitch(true)
                this.markModuleForQuiz();

            }
        },
        modalNonQuizOptionSelected: function(){
            if(this.modal_module_current.without_quiz){
                return
            }else{
               // this.modal_module_current.module.duration -= (15*60)
               let temp_val_quiz = this.modal_module_current.with_quiz
                this.modal_module_current.quiz_updated = true
                this.modal_module_current.with_quiz = false
                this.modal_module_current.without_quiz = true
                //switch back to base version
                if(temp_val_quiz){
                  this.moduleQuizBaseDataSwitch(false)
                }
              
            }
        },
        toggleQuizOption: function(){
            var params = {
                id : this.id,
                module_id : this.modal_module_current.initial_id
            }
            this.$store.dispatch('toggleQuizModule', params).then((res) =>{
                this.modal_module_current.quiz_updated = false
                this.updateProgram();
            })

        },
        getModuleQuizData: function(selected_id){
            if(this.modal_module_current.module[selected_id] == null ){
                return
            }
            var params ={
                id: this.modal_module_current.module[selected_id],
                filters:{
                    full:true
                }
            }
            this.$store.dispatch('getModule', params).then((res) => {
                if(selected_id == "quiz_module_id"){
                    this.modal_module_current.quiz_module = res.data.data
                }else{
                    this.modal_module_current.base_module = res.data.data
                }
                //this.moduleQuizBaseDataSwitch(true)
            })
        },
        moduleQuizBaseDataSwitch(switch_to_quiz){
            // get quiz module data and inject to module's data
            if(switch_to_quiz){
                let temp_module = this.modal_module_current.module
                if(temp_module.added){
                    this.modal_module_current.quiz_module.added = true
                }
                this.modal_module_current.module = this.modal_module_current.quiz_module
                this.modal_module_current.base_module = temp_module
            }else{
                let temp_module = this.modal_module_current.module
                 if(temp_module.added){
                    this.modal_module_current.base_module.added = true
                }
                this.modal_module_current.module = this.modal_module_current.base_module
                this.modal_module_current.quiz_module = temp_module
            }
        },
        closeModal: function(){
            this.show_remove_module = false
            this.show_modal_current_module = false
            this.show_in_class_modal = false
            this.modal_module_current = {
                module:{},
                with_quiz:false,
                without_quiz:false,
                quiz_updated:false,
                initial_id:'',
                initial_selection_with_quiz:'',
                initial_selection_without_quiz:'',
                quiz_module:{
                    lessons:[
                        {duration:'NA'}
                    ]
                }
            }
        },
        openRemoveModuleDialog: function(){
            this.show_modal_current_module = false
            this.show_remove_module = true
        },
        openModuleFromcart:function(module){
            this.module_list.filter((elem,index) =>{
                if(elem.id == module.id){
                   
                    this.openModal(elem, index)
                    return
                }
            })
        },
        openModal: function(module,index){
            this.modal_module_current.module = module
            this.modal_module_current.initial_id = module.id
            if(module.added){
                this.modal_module_current.initial_id = module.id
                this.modalQuizOptionCheck(module)
                this.modal_module_current.initial_selection_with_quiz =  this.modal_module_current.with_quiz 
                this.modal_module_current.initial_selection_without_quiz =  this.modal_module_current.without_quiz 
            } else {
                // need to add base module first
                this.modal_module_current.base_module = this.modal_module_current.module
            }
            
            this.modal_module_current.index = index
            this.show_modal_current_module = true
        },
        openInClassModal: function() {
            this.show_in_class_modal = true;
        },
        /*
        * If module saved with quiz or base option when we open we get the state back. 
        * Module IDs are deciding whether it is quiz module or base module
        */
        modalQuizOptionCheck(module){
            //find the same module on your cart
            if(module.base_module_id != null){
                this.markModuleForQuiz()
                this.getModuleQuizData("base_module_id")

            }
            else{
                this.markModuleForNonQuiz()
            }
        },
        markModuleForQuiz(){
          //  this.modal_module_current.module.duration += (15*60)
            this.modal_module_current.with_quiz = true
            this.modal_module_current.without_quiz = false
        },
        markModuleForNonQuiz(){
          //  this.modal_module_current.module.duration += (15*60)
            this.modal_module_current.with_quiz = false
            this.modal_module_current.without_quiz = true
        },
        filterInput(){
            if(this.module_list == [] && this.language_array_.length == 0){
                this.getExistingModules(false)
            }else{
                this.getExistingModules(true)
            }
        },
         getAvailableLanguages() {
            var params = { available_for_users: 1 };
            this.$store.dispatch("getLanguages", params).then(res => {
                	let languages = res.data.data
					for( let i in languages){
                        if(languages[i].available_for_users == 1){
					    	this.languages_all.push({id:languages[i].code_2, name:languages[i].name})

                        }
					}
					this.languages_all.push({
						id : '-1',
						name : 'None'
					});
            });
				
		},
         getAvailableCategories() {
            var params = {};
            this.$store.dispatch("getCategories", params).then(res => {
                this.category_all = res.data.data
            });
				
		},
        keyUpSearchExistingModules:function(){
            //setPage to 1, clean the list
            this.module_list = []
            setTimeout( () => {this.getExistingModules(true)},1000)

        },
        changeEdit:function(){
            console.log('change edit')
        },
        updateModuleInCart: function(module, index){
             this.module_list[index] = module
             //update on the current_program level too
             if((this.modal_module_current.initial_selection_without_quiz != this.modal_module_current.without_quiz) || (this.modal_module_current.initial_selection_with_quiz != this.modal_module_current.with_quiz)
             ){
                 this.toggleQuizOption();
                

             }
             this.current_program.modules.filter((elem, index) => {
                 let search_section = (elem.base_module_id != null) ? "base_module_id": ((elem.quiz_module_id != null) ? "quiz_module_id" : "id")
                  if(elem.id == module[search_section]){
                   this.current_program.modules[index] = module
                  
             }}) 
             this.show_modal_current_module = false
             this.closeModal();
        },
        addModuleToCart: function(module_object,index){
            var params = {
                modules:1,
                id: parseInt(this.id),
                module_id: this.modal_module_current.module.id
            }
            this.$store.dispatch('addModuleToDraft',params).then((res) =>{
                this.current_program = res.data.course
                this.modal_module_current.module.added = true
                this.module_list[index].added = true
                this.module_list[index] = this.modal_module_current.module
                this.closeModal();
            }).catch((error) => {
                console.log(error)
            })
          
        },
        addCustomModuleToCart: function() {
            var durationInSeconds = (this.custom_module.duration.hours * 3600) + (this.custom_module.duration.minutes * 60);

            // Validate Title
            if (this.custom_module.name.trim().length === 0) {
                this.show_custom_error_title = true;
            } else {
                this.show_custom_error_title = false;
            }

            // Validate Duration
            if (durationInSeconds === 0) {
                this.show_custom_error_dur = true;
            } else {
                this.show_custom_error_dur = false;
            }

            if (this.show_custom_error_dur === true || this.show_custom_error_title === true) { return }

            var data = {
                course_id: parseInt(this.id),
                name: this.custom_module.name,
                description: this.custom_module.description,
                duration: durationInSeconds,
                order: this.custom_module.order,
                notes: this.custom_module.notes,
                external_link: this.custom_module.external_link,
                modules: 1,
            }

            this.$store.dispatch('addCustomModuleToDraft', data).then((res) =>{
                this.current_program = res.data.course
                this.closeModal();
            }).catch((error) => {
                console.log(error)
            })
          
        },
        removeModuleFromChart:function(module_to_remove, modal_detail_view){
            //reset modal
            this.show_remove_module = false
            if(modal_detail_view){
                this.modal_module_current.module.added = false
                let temp_module_index = this.current_program.modules.filter((elem, index) => { if(elem.id == module_to_remove.id){
                    return index
                }})
                this.current_program.modules.splice(temp_module_index,1)
                this.removeModuleFromProgram(module_to_remove, this.modal_module_current.index)
                // this.closeModal();

            }
            else{
                //check if module needs to be removed is present on the module list / 
                //If not, just remove it from the program -  no need to change view from the module list side.
                let is_module_remove_index = this.moduleExistInList(module_to_remove)
               if(is_module_remove_index){
                    this.removeModuleFromProgram(module_to_remove,is_module_remove_index)
               }else{
                   this.justRemoveModuleFromChart(module_to_remove)
               }
            }
            
        },
        moduleExistInList(module_to_remove){
            let search_ids = ["base_module_id","quiz_module_id","id"]
            let elem_index = null
             // search with which id of the module

            this.module_list.filter((elem, index) => {
                for(let i in search_ids){
                    if(elem[search_ids[i]] == module_to_remove.id){
                        elem.added = false
                        //this.current_program.modules.splice(module.index,1)
                        elem_index = index
                    }
                }
            })
           return elem_index
        },
        justRemoveModuleFromChart(module_to_delete){
            var params = {
                id : this.id,
                module_id : module_to_delete.id
            }
             this.$store.dispatch('deleteModuleCourse', params).then((res) => {
                this.getProgram()
            }).catch((error) => {
                console.log(error);
            });
        },
        removeModuleFromProgram(module_to_delete,index){
            var params = {
                id : this.id,
                module_id : module_to_delete.id
            }
            this.$store.dispatch('deleteModuleCourse', params).then((res) => {
                //check if module has base_module, if yes switch with module list valueType
                if(this.modal_module_current.base_module){
                    this.module_list[index] = this.modal_module_current.base_module
                }
                 this.module_list[index].added = false
                 this.closeModal();
                
                this.updateProgram()
            }).catch((error) => {
                console.log(error);
            });

        },
        getProgram: function(){
            var params = {
                id: this.id,
                filters : {
                    full: true
                }
            }
            this.$store.dispatch('getDraft', params).then((res) => {
					this.current_program = res.data.data;
                    this.show_cart = true
                    
            }).catch((error) => {
                console.log(error);
            })
        },
        markAddedModules : function(module_list){
            let new_module_list = module_list
            let search_ids = ["base_module_id","quiz_module_id","id"]
            this.current_program.modules.forEach( cart_modules =>{
                new_module_list.filter((elem,index) =>{
                    // search with which id of the module
                    for(let i in search_ids){
                        if(elem[search_ids[i]] == cart_modules.id){
                            if(cart_modules.base_module_id != null){
                                // this is added as quiz, go and upload the quiz version of this one the main list
                                // this.updateAddedQuizModules(elem, 'quiz_module_id', index)
                                new_module_list[index] = cart_modules
                                new_module_list[index].added = true
                            }else{
                                elem.added = true
                            }
                            return
                        }else if(elem.added != true && elem.id != cart_modules.id){
                            elem.added = false
                        }
                    }

                  
                })
            })
            return new_module_list
        },
        updateProgramWait: function(){
            setTimeout( () => {
                 this.updateProgram()
            } ,50)
            //this.updateProgram()
        },
        updateProgram: function(){
            this.$store.dispatch('editDraft', this.current_program).then((res) => {
                this.$nextTick(()=>{
			    	this.current_program = res.data.course
                    this.$forceUpdate();

                })
            }).catch((error) => {
                console.log(error);
            });
        },
        getExistingModules : function(reset_list){
            this.loading_table_providers = true
            if(reset_list){
                this.page = 1
            }else{
                this.page++
            }
            this.$store.commit('setPageLoading', false)
            var params = { 
                filters : { 
                    sort: this.sorting_array_.id,
                    languages: this.language_array,
                    categories: this.category_array,
                    full : true, 
                    page : this.page,
                    search : this.module_search_key,
                    per_page : 12,
                    page_loading: false,
                    in_library: 1
                }
            }
            this.$store.dispatch('getModules', params).then((res) => {
                this.$store.commit('setPageLoading', false)
                this.no_module_return = (res.data.data.length == 0) ? true : false
                let new_list = this.markAddedModules(res.data.data)
                // set module list to empty array
                if(reset_list){
                    this.module_list = []
                    this.module_list = new_list;
                }else{
                    // we add module to the existing list
                    this.module_list = this.module_list.concat(new_list)
                }
                 this.$store.commit('setPageLoading', false)
                setTimeout( () => {
                 this.loading_table_providers = false
                 this.$store.commit('setPageLoading', false)
                 document.body.classList.remove('refreshing');
                },1000)
                // this.pagination_existing_modules = res.data.meta;
            }).catch((error) => {
                 document.body.classList.remove('refreshing');
                this.loading_table_providers = false
            });
		}
    }
};
</script>
<style scoped src="./Shopify.css">

</style>



// WEBPACK FOOTER //
// src/components/shopify/ShopifyModuleList.vue